import React from "react";

import CorrectionLevelHelper from "../../../../../lib/UniversalTable/RendererHelpers/CorrectionLevelHelper";
import universalTableStockIdExtractor from "../../../../../lib/UniversalTable/universalTableStockIdExtractor";
import withQuoteData from "../../../../../hocs/withQuoteData";

const CorrectionLevelFromFirebase = ({ quoteData, resultMetaData }) => {
  const currentPrice =
    quoteData?.close !== null && typeof quoteData?.close !== "undefined"
      ? quoteData.close
      : resultMetaData?.current_price;

  const mergedRow = {
    ...resultMetaData,
    current_price: currentPrice
  };

  return (
    <div className="number-renderer">
      {CorrectionLevelHelper.render(mergedRow) ?? "-"}
    </div>
  );
};

export default withQuoteData(
  false,
  universalTableStockIdExtractor
)(CorrectionLevelFromFirebase);
